import { useWebsiteSettings } from 'client/store'
import { AlignType } from 'common/types/styleTypes'
import { useHeadingFontSize } from './use-heading-font-size'
import { useHeadingLineHeight } from './use-heading-line-height'
import { useHeadingTextAlign } from './use-heading-text-align'
import { getWebsiteStylesTypographyHeading } from 'src/editor/store/website-settings/website-settings-selector'
import { useHeadingLetterSpacing } from './use-heading-letter-spacing'

export const useHeadingTypography = ({
  fontSize,
  mobileFontSize,
  lineHeight,
  mobileLineHeight,
  textAlign,
  mobileTextAlign,
  letterSpacing,
  mobileLetterSpacing,
}: {
  fontSize?: number
  mobileFontSize?: number
  lineHeight?: number
  mobileLineHeight?: number
  textAlign?: AlignType
  mobileTextAlign?: AlignType
  letterSpacing?: number
  mobileLetterSpacing?: number
}) => {
  const { fontFamily: globalFontFamily } =
    useWebsiteSettings(getWebsiteStylesTypographyHeading) || {}

  const returnUseFontSize = useHeadingFontSize({
    fontSize,
    mobileFontSize,
  })

  const returnUseLineHeight = useHeadingLineHeight({
    fontSize,
    mobileFontSize,
    lineHeight,
    mobileLineHeight,
  })

  const returnUseTextAlign = useHeadingTextAlign({
    textAlign,
    mobileTextAlign,
  })

  const returnUseLetterSpacing = useHeadingLetterSpacing({
    letterSpacing,
    mobileLetterSpacing,
  })

  return {
    ...returnUseFontSize,
    ...returnUseLineHeight,
    ...returnUseTextAlign,
    ...returnUseLetterSpacing,
    globalFontFamily,
  }
}
